export function Description() {
  return (
    <div className="
    font-roboto leading-tight px-2 
    text-center text-sm text-yellow-400 bg-black/30 p-2 rounded-md mx-4">
      Soutenez l'association <span className="font-bold text-white underline">
        MO5</span><br />
      Votre contribution est essentielle pour continuer notre mission.
    </div>
  );
}
